import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export const RenderText = ({ text }) => {
    let children = _jsx(_Fragment, { children: text.text });
    if (text.bold) {
        children = _jsx("strong", { children: children });
    }
    if (text.italic) {
        children = _jsx("em", { children: children });
    }
    if (text.underline) {
        children = _jsx("u", { children: children });
    }
    return children;
};
